import { createSlice } from "@reduxjs/toolkit";

const loc = [
    {
        "name": "Velachery",
        "lat": "12.978115444712085",
        "lng": "80.20846569416207",
        "loc_id": "gd_vel_1",
        "locUrl": "https://maps.app.goo.gl/v9D5ChD1D891noyZ8"
    },
    {
        "name": "Mylapore",
        "lat": "13.043511187944821",
        "lng": "80.27717013649186",
        "loc_id": "gd_myl_5",
        "locUrl": "https://maps.app.goo.gl/5C8fcNjsTYwmmNbW7"
    }
]

/* const initialState = {
    locations: [],
    fetchedGdInfo: false
}; */

const initialState = {
    locations: loc,
    fetchedGdInfo: true
};

const gdInfoSlice = createSlice({
    name: "gsInfoSlice",
    initialState,
    reducers: {
        updateGdInfo: (state, action) => {
            return { ...state, ...action.payload, fetchedGdInfo: true };
        },
        clearGdInfo: () => {
            return initialState;
        },
    },
})

export const { updateGdInfo, clearGdInfo } = gdInfoSlice.actions;
export default gdInfoSlice.reducer;